import { createPublicClient, http } from "viem";
import { optimismGoerli, optimism, polygonMumbai, polygon, base, baseGoerli, lineaTestnet, linea, } from "viem/chains";
const testnetChains = [optimismGoerli, polygonMumbai, baseGoerli, lineaTestnet];
const mainnetChains = [optimism, polygon, base, linea];
const supportedChains = [...testnetChains, ...mainnetChains];
const publicClients = supportedChains.reduce((clients, chain) => ({
    [chain.id]: (url) => createPublicClient({
        chain,
        transport: http(url, { retryCount: 0 }),
    }),
    ...clients,
}), {});
export { publicClients };
